import { Button } from "antd";
import { AddCascadeForm } from "components/Forms/AddCascadeForm/AddCascadeForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddCascadeDrawerProps {
    offerId: string;
    sort: number;
    onSuccess?: () => void;
}

export const AddCascadeDrawer: FC<AddCascadeDrawerProps> = ({ offerId, sort, onSuccess }) => {
    const { t } = usePaldockTranslation("drawers.add-cascade");
    const { t: tC } = usePaldockTranslation("common");
    const drawerId = DrawerId.AddCascade;
    const drawerUtils = useDrawer();
    const formId = FormId.AddCascadeForm;

    const handleSuccess = () => {
        drawerUtils.hide(drawerId);
        onSuccess?.();
    };

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size="large" type="primary" htmlType="submit" form={formId}>
                    {tC("create")}
                </Button>
            }
        >
            <DrawerContent>
                <AddCascadeForm offerId={offerId} formId={formId} sort={sort} onSuccess={handleSuccess} />
            </DrawerContent>
        </Drawer>
    );
};
